module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-doc_white.dada2ccb.svg";